<template>
  <div class="min-h-screen flex flex-col">
    <!-- Global Navigation -->
    <TopNav>
      <template #actions>
        <slot name="nav-actions"></slot>
      </template>
    </TopNav>

    <!-- Main Content Area -->
    <div class="flex-1 bg-white dark:bg-black">
      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import TopNav from '../components/TopNav.vue'
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()

// Set page title based on current route's meta
useHead({
  title: computed(() => {
    const currentRoute = route.matched[route.matched.length - 1]
    return currentRoute?.meta?.title ? `${currentRoute.meta.title} | Plaza Muffler` : 'Plaza Muffler'
  })
})
</script>

<script lang="ts">
export default {
  name: 'InvoiceLayout'
}
</script> 